import { render, staticRenderFns } from "./misionesRecompensas.vue?vue&type=template&id=34d226d6&scoped=true&"
import script from "./misionesRecompensas.vue?vue&type=script&lang=js&"
export * from "./misionesRecompensas.vue?vue&type=script&lang=js&"
import style0 from "./misionesRecompensas.vue?vue&type=style&index=0&id=34d226d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d226d6",
  null
  
)

export default component.exports